/* eslint-disable @typescript-eslint/no-explicit-any */
import List from '@mui/material/List'
import { ListItemText, useTheme } from '@mui/material'
import { CategoriesListProps, CategoryListItem } from './CategoriesList.types'
import Icon from '../Icon'
import getPaletteColor from '../../../utils/getPaletteColor'
import { CategoryHeader, CategoryListComponent } from './CategoriesList.styles'
import Heading from '../Heading'
import { SkeletonHeading, SkeletonCategories } from './CategoriesList.skeletons'

const CategoriesList = ({
  categories,
  headerText,
  actions,
  isLoading = false
}: CategoriesListProps) => {
  const theme = useTheme()
  const handleClick = (event: any, data: any) => {
    event.preventDefault()
    event.stopPropagation()
    actions?.({
      data
    })
  }

  const getCategoryListItem = (category: CategoryListItem) => {
    const { hasChildren = true, id, name } = category
    return (
      <CategoryListComponent key={id} onClick={(e) => handleClick(e, category)}>
        <ListItemText primary={name} />
        {hasChildren && (
          <Icon
            name="MdArrowForwardIos"
            color={getPaletteColor(theme, 'primary')}
          />
        )}
      </CategoryListComponent>
    )
  }
  if (isLoading || categories.length === 0) {
    return (
      <>
        <SkeletonHeading />
        <SkeletonCategories />
      </>
    )
  }

  return (
    <>
      <CategoryHeader>
        <Heading variant="h2">{headerText}</Heading>
      </CategoryHeader>
      <List>{categories.map(getCategoryListItem)}</List>
    </>
  )
}

export default CategoriesList
